import React from 'react';
import { Table } from '@mairistem/composants';
import { map } from 'lodash';
import naturesJuridiquesPes from '../../../../constants/tiers/naturesJuridiquesPes';

const NatJuridiqueCatPesHeader = () => (
  <Table.Header>
    <Table.Row>
      <Table.HeaderCell key="00">Nature Juridique</Table.HeaderCell>
      {map(naturesJuridiquesPes, (natJur) => (
        <Table.HeaderCell key={natJur.key} rowSpan={2}>
          {natJur.text}
        </Table.HeaderCell>
      ))}
    </Table.Row>
    <Table.Row>
      <Table.HeaderCell>Catégorie</Table.HeaderCell>
    </Table.Row>
  </Table.Header>
);

export default NatJuridiqueCatPesHeader;
